import { createSelector } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TFactoryProductLineEfficiencyState } from './product-line-efficiency.models';

export const getFactoryProductLineEfficiencyInfo = (state: TPlani8State) => state.factoryProductLineEfficiencyInfo;

export const getFactoryProductLineEfficieny = createSelector(
  getFactoryProductLineEfficiencyInfo,
  (state: TFactoryProductLineEfficiencyState) => state.factoryLineEfficiencyInfo,
);
